import { observer } from 'mobx-react';
import { useEffect } from 'react';
import FoodicsAuthorizationForm from '../../components/FoodicsAuthorizationForm/FoodicsAuthorizationForm';
import FoodicsAuthorizedForm from '../../components/FoodicsAuthorizedForm/FoodicsAuthorizedForm';
import { SCREENS } from 'src/constants/screens';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import foodicsIntegrationStore from 'src/view/screens/SettingsScreen/store/foodicsIntegrationStore';
import FoodicsLogLink from '~/view/components/FoodicsLogLink/FoodicsLogLink';

const FoodicsScreen = observer((): JSX.Element => {
  useEffect(() => {
    foodicsIntegrationStore.getSettings();
    return () => {
      foodicsIntegrationStore.unMount();
    };
  }, []);

  return (
    <div className="d-flex flex-column full-width integration-settings-page">
      <Headers>
        <HeaderBack title="foodics" path={SCREENS.SETTINGS_INTEGRATIONS()} />
      </Headers>
      {!foodicsIntegrationStore.isLoading ? (
        foodicsIntegrationStore.integrationSettings?.enabled ? (
          <FoodicsAuthorizedForm />
        ) : (
          <FoodicsAuthorizationForm auth_route={foodicsIntegrationStore.integrationSettings?.settings.authorize_route} />
        )
      ) : null}
      <FoodicsLogLink />
    </div>
  );
});

export default FoodicsScreen;
